// Pure profile DATA — no `import.meta.env`, no React, no imports at all.
// `vite.config.ts`, sync-routes' vite server and vitest all import this file
// outside the app bundle, so it must stay import-free and side-effect-free.

export type BuildSiteId = "slate" | "appcoil";

export interface SiteConfig {
  id: BuildSiteId;
  appName: string;
  wordmark: string;
  htmlTitle: string;
  htmlDescription: string;
  htmlLang: "en" | "he";
  htmlDir: "ltr" | "rtl";
  noindex: boolean;
  rootRedirect: string | null;
  navSectionOrder: string[];
}

export const SITE_CONFIGS: Record<BuildSiteId, SiteConfig> = {
  slate: {
    id: "slate",
    appName: "Slate",
    wordmark: "Slate",
    htmlTitle: "Slate",
    htmlDescription: "Slate — application shell",
    htmlLang: "en",
    htmlDir: "ltr",
    noindex: false,
    rootRedirect: null,
    navSectionOrder: [
      "knowledge",
      "primary",
      "work",
      "workspace",
      "marketplace",
      "people",
      "storage",
      "admin",
    ],
  },
  appcoil: {
    id: "appcoil",
    appName: "app.co.il",
    wordmark: "app.co.il",
    htmlTitle: "app.co.il — המרחב שלי",
    htmlDescription: "app.co.il — המרחב שלי",
    htmlLang: "he",
    htmlDir: "rtl",
    noindex: true,
    rootRedirect: "/market",
    // Owner 2026-10-24: my.app.co.il shows marketplace, people and work ONLY; every other area
    // stays behind the scenes until its own plan turns it on. This list is that switch — a
    // section absent here is out of the menus AND its routes redirect to rootRedirect
    // (nav.ts `isPathHiddenOnSite`). Turning an area on is adding its id; there is no second list.
    navSectionOrder: ["marketplace", "people", "work"],
  },
};
